import type {
    CustomData,
    CustomDataMap,
    DatapointOptions,
    INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT,
    InternalDatapointOptions,
    TraceErrorObject,
} from 'owa-analytics-types';
import type { MailboxInfo } from 'owa-client-types';
import { tryGetTraceObjectErrorFromApolloError } from 'owa-trace/lib/tryGetTraceObjectErrorFromApolloError';
import { AriaDatapoint } from './AriaDatapoint';
import { addErrorToCustomData } from 'owa-analytics-utils/lib/addErrorToCustomData';
import { addEncounteredErrorCode } from 'owa-error-codes';

export default class GreyErrorDatapoint extends AriaDatapoint {
    private originalCustomData?: CustomDataMap;

    constructor(
        eventName?: string,
        mailbox?: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined,
        error?: TraceErrorObject,
        customData?: CustomData,
        options?: DatapointOptions,
        originalCustomData?: CustomDataMap
    ) {
        super(eventName, mailbox, customData, options);

        (this.options as InternalDatapointOptions).isGreyError = true;

        const traceError = tryGetTraceObjectErrorFromApolloError(error);
        if (traceError) {
            const { datapointName, customData: errorCustomData } = addErrorToCustomData(
                traceError.message,
                traceError
            );
            if (!eventName && datapointName) {
                this.eventName = datapointName;
            }
            this.addCustomData(errorCustomData);
        }

        if (originalCustomData) {
            this.originalCustomData = originalCustomData;
        }

        if (error?.owaErrorCode) {
            addEncounteredErrorCode(error.owaErrorCode, this.eventName);
            this.addData('ErrorCode', error.owaErrorCode);
        }
    }

    getOriginalCustomData(): CustomDataMap | undefined {
        return this.originalCustomData;
    }
}
